import { useState, useCallback } from 'react'
import { radiusByZoom } from '../utils'

interface UseStoreZoomTrackingParams {
  initialRadiusValue?: number
  setHasUserZoomed: (hasUserZoomed: boolean) => void
  isAutomaticZoomOut: boolean
}

interface UseStoreZoomTrackingReturn {
  zoom: number
  initialZoomIndex: number
  setZoom: (zoom: number) => void
  handleZoomIn: (updatedZoom: number) => void
  handleZoomOut: (updatedZoom: number) => void
  resetZoomTracking: () => void
}

export const useStoreZoomTracking = (
  params: UseStoreZoomTrackingParams
): UseStoreZoomTrackingReturn => {
  const { initialRadiusValue, isAutomaticZoomOut, setHasUserZoomed } = params

  const initialZoomIndex = radiusByZoom.findIndex(
    (i) => i <= (initialRadiusValue ?? 7)
  )
  const [zoom, setZoom] = useState(initialZoomIndex)

  const handleZoomIn = useCallback(
    (updatedZoom: number) => {
      setZoom(updatedZoom)
      if (updatedZoom !== initialZoomIndex && !isAutomaticZoomOut) {
        setHasUserZoomed(true)
      }
    },
    [initialZoomIndex]
  )

  const handleZoomOut = useCallback(
    (updatedZoom: number) => {
      setZoom(updatedZoom)
      if (updatedZoom !== initialZoomIndex && !isAutomaticZoomOut) {
        setHasUserZoomed(true)
      }
    },
    [initialZoomIndex, isAutomaticZoomOut]
  )

  const resetZoomTracking = useCallback(() => {
    setZoom(initialZoomIndex)
    setHasUserZoomed(false)
  }, [initialZoomIndex])

  return {
    zoom,
    initialZoomIndex,
    setZoom,
    handleZoomIn,
    handleZoomOut,
    resetZoomTracking
  }
}
